var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{staticStyle:{"width":"100%","display":"flex"},attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","lg4":""}},[_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }